import React from 'react';
import RiskTakingSearch from './components/riskTaking/RiskTakingSearch';

const RiskTakingPage = () => {
    return <RiskTakingSearch />;
};

export default RiskTakingPage;
